import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTabs from "../../../../global/components/CustomTabs/CustomTabs1";
import { handleErrorMessage } from "../../../../helpers/methods";
import { getShadbalaData } from "../../AnalysisService";
import ShadbalaChartComponent from "./ShadbalaChartComponent";
import ShadbalaTable from "./ShadbalaTable";

interface CustomProps {
  profileId: string;
  setIsLoading: Function;
}

const Shadbala = (props: CustomProps) => {
  const { t, i18n } = useTranslation();
  const [tabValue, setTabValue] = useState(`${t("shadbalaGraphs")}`);
  const [data, setData] = useState<Record<string, any> | undefined>();

  const tabConfig = [
    {
      label: `${t("shadbalaGraphs")}`,
    },
    {
      label: `${t("shadbalaTable")}`,
    },
  ];

  useEffect(() => {
    getShadbalaDetails();
  }, []);

  useEffect(() => {
    setTabValue(`${t("shadbalaGraphs")}`);
  }, [i18n.language]);

  const getShadbalaDetails = async () => {
    try {
      props.setIsLoading(true);
      const response = await getShadbalaData(props?.profileId!);
      setData(response);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleChange = (newValue: string) => {
    setTabValue(newValue);
  };

  const shadbalaGraphKeys: { key: string; labelKey: string }[] = [
    { key: "shadbala", labelKey: "shadbala" },
    { key: "shadbalarupas", labelKey: "shadbalarupas" },
    { key: "sthana", labelKey: "sthana" },
    { key: "kala", labelKey: "kala" },
    { key: "dig", labelKey: "dig" },
    { key: "chesta", labelKey: "chesta" },
    { key: "drigbala", labelKey: "drigbala" },
    { key: "naisargika", labelKey: "naisargika" },
  ];

  const getShadbalaGraphs = () => (
    <Grid container spacing={3} sx={{ py: 2 }}>
      {shadbalaGraphKeys.map(({ key, labelKey }) => {
        const chartData = data?.[key];
        if (!chartData || typeof chartData !== "object") return null;
        const title =
          t(labelKey) !== labelKey
            ? t(labelKey)
            : labelKey.charAt(0).toUpperCase() + labelKey.slice(1);
        return (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={key}>
            <ShadbalaChartComponent data={chartData} title={title} />
          </Grid>
        );
      })}
    </Grid>
  );

  const getComponentBasedOnValue = () => {
    if (tabValue === `${t("shadbalaGraphs")}`) {
      return getShadbalaGraphs();
    }
    if (tabValue === `${t("shadbalaTable")}`) {
      return <ShadbalaTable shadbalaDetails={data?.shadbala_details} />;
    }
    return null;
  };

  const getShadbala = () => {
    return (
      <Box pt={2}>
        <CustomTabs
          changeValue={handleChange}
          selected={tabValue}
          tabConfig={tabConfig}
        />
        {data && getComponentBasedOnValue()}
      </Box>
    );
  };

  return getShadbala();
};

export default Shadbala;
